import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/logo.png';
const _withScopeId = n => (_pushScopeId("data-v-e995047c"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "supportOne-box"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "logo"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_0
})], -1));
const _hoisted_3 = {
  class: "content"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "nav-0"
}, [/*#__PURE__*/_createTextVNode("Main "), /*#__PURE__*/_createElementVNode("span", null, "— Contact")], -1));
const _hoisted_5 = {
  key: 0
};
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, "Contact Information", -1));
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "address"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "name"
}, "Shenzhen"), /*#__PURE__*/_createElementVNode("div", null, "Company Address：3rd Floor, Building B, Nankeng First Industrial Zone, Bantian Street, Longgang District, Shenzhen, Guangdong Province"), /*#__PURE__*/_createElementVNode("div", {
  class: "phone"
}, [/*#__PURE__*/_createElementVNode("div", null, "+86 19925424372 Tina"), /*#__PURE__*/_createElementVNode("div", null, "Service@Sabbat.cn")])], -1));
const _hoisted_8 = {
  key: 1
};
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, "联系信息", -1));
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "address"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "name"
}, "深圳"), /*#__PURE__*/_createElementVNode("div", null, "公司地址：广东省深圳市龙岗区坂田街道南坑第一工业区B栋3楼"), /*#__PURE__*/_createElementVNode("div", {
  class: "phone"
}, [/*#__PURE__*/_createElementVNode("div", null, "+86 19925424372 Tina"), /*#__PURE__*/_createElementVNode("div", null, "Service@Sabbat.cn")])], -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_map_temp = _resolveComponent("map-temp");
  const _component_NavBottom = _resolveComponent("NavBottom");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _createElementVNode("div", _hoisted_3, [_hoisted_4, $data.lang === 1 ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_hoisted_6, _createVNode(_component_map_temp, {
    class: "map"
  }), _hoisted_7])) : $data.lang === 2 ? (_openBlock(), _createElementBlock("div", _hoisted_8, [_hoisted_9, _createVNode(_component_map_temp, {
    class: "map"
  }), _hoisted_10])) : _createCommentVNode("", true)]), _createVNode(_component_NavBottom)]);
}